import { VehicleSkins, VehicleSkinsValues } from './CharacterSpine';
import { Sounds } from '../../sounds';
import { EquipmentType, EquipmentTypeValues } from './VehicleEquipment';

export const CharacterName = {
  Bam: 'bam',
  Prank: 'prank',
  Bibi: 'bibi',
  Jestah: 'jestah',
  Batwing: 'batwing',
  Quizz: 'quizz',
  Redbird: 'redbird',
  Ducky: 'ducky',
  Buff: 'buff',
  Snowy: 'snowy'
} as const;
export type CharacterNameKeys = keyof typeof CharacterName;
export type CharacterNameValues = typeof CharacterName[CharacterNameKeys];

export const CharacterVillain = {
  [CharacterName.Prank]: CharacterName.Prank,
  [CharacterName.Jestah]: CharacterName.Jestah,
  [CharacterName.Quizz]: CharacterName.Quizz,
  [CharacterName.Ducky]: CharacterName.Ducky,
  [CharacterName.Snowy]: CharacterName.Snowy
};
export type CharacterVillainKeys = keyof typeof CharacterVillain;
export type CharacterVillainValues = typeof CharacterVillain[CharacterVillainKeys];

export const Heroes: Set<CharacterNameValues> = new Set([CharacterName.Bam, CharacterName.Bibi]);
export const Villains: Set<CharacterNameValues> = new Set([CharacterName.Prank, CharacterName.Jestah]);

export interface CharacterData {
  topSpeedUpgrades: number;
  accelerationUpgrades: number;
}

export interface VehicleShadow {
  key: string;
  frame: string;
  offsetX: number;
  offsetY: number;
}

export class Character {
  public static characterSkinLookup: Record<CharacterNameValues, VehicleSkinsValues> = {
    [CharacterName.Bam]: VehicleSkins.Bam,
    [CharacterName.Prank]: VehicleSkins.Prank,
    [CharacterName.Bibi]: VehicleSkins.Bibi,
    [CharacterName.Jestah]: VehicleSkins.Jestah,
    [CharacterName.Batwing]: VehicleSkins.Batwing,
    [CharacterName.Quizz]: VehicleSkins.Quizz,
    [CharacterName.Redbird]: VehicleSkins.Redbird,
    [CharacterName.Ducky]: VehicleSkins.Ducky,
    [CharacterName.Buff]: VehicleSkins.Buff,
    [CharacterName.Snowy]: VehicleSkins.Snowy
  };

  public static skinToCharacterLookup: Record<VehicleSkinsValues, CharacterNameValues> = {
    [VehicleSkins.Bam]: CharacterName.Bam,
    [VehicleSkins.Prank]: CharacterName.Prank,
    [VehicleSkins.Bibi]: CharacterName.Bibi,
    [VehicleSkins.Jestah]: CharacterName.Jestah,
    [VehicleSkins.Batwing]: CharacterName.Batwing,
    [VehicleSkins.Quizz]: CharacterName.Quizz,
    [VehicleSkins.Redbird]: CharacterName.Redbird,
    [VehicleSkins.Ducky]: CharacterName.Ducky,
    [VehicleSkins.Buff]: CharacterName.Buff,
    [VehicleSkins.Snowy]: CharacterName.Snowy
  };

  public static characterToSoundLookup: Record<CharacterNameValues, Sounds.CharacterValues> = {
    [CharacterName.Bam]: Sounds.Character.Bam,
    [CharacterName.Prank]: Sounds.Character.Prank,
    [CharacterName.Bibi]: Sounds.Character.Bibi,
    [CharacterName.Jestah]: Sounds.Character.Jestah,
    [CharacterName.Batwing]: Sounds.Character.Batwing,
    [CharacterName.Quizz]: Sounds.Character.Quizz,
    [CharacterName.Redbird]: Sounds.Character.Redbird,
    [CharacterName.Ducky]: Sounds.Character.Ducky,
    [CharacterName.Buff]: Sounds.Character.Buff,
    [CharacterName.Snowy]: Sounds.Character.Snowy
  };

  public static characterToEquipmentLookup: Record<CharacterNameValues, EquipmentTypeValues[]> = {
    [CharacterName.Bam]: [EquipmentType.MagCable],
    [CharacterName.Prank]: [EquipmentType.BoxingGlove],
    [CharacterName.Bibi]: [EquipmentType.Grapple],
    [CharacterName.Jestah]: [EquipmentType.GiantMallet],
    [CharacterName.Batwing]: [EquipmentType.NetSteel],
    [CharacterName.Quizz]: [EquipmentType.SkyWriting],
    [CharacterName.Redbird]: [EquipmentType.Laser],
    [CharacterName.Ducky]: [EquipmentType.Ink],
    [CharacterName.Buff]: [EquipmentType.Crane],
    [CharacterName.Snowy]: [EquipmentType.SnowBlower]
  };
}
